<template>
  <div class="dialog-wrap">
    <el-dialog title="编辑推广商品"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="520px">
      <el-form ref="dataForm"
               :model="dataForm"
               :rules="rules"
               label-width="100px">
        <el-form-item label="推广类型">
          <el-input :value="formatFosterType(dataForm.foster_type)" readonly></el-input>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select v-model="productType" @change="handleProductTypeChange">
            <el-option label="课程" :value="1"></el-option>
            <el-option label="题库" :value="2"></el-option>
            <el-option label="专栏" :value="3"></el-option>
            <el-option label="资料" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择商品" prop="product_name">
          <el-input :value="dataForm.product_name"
                    placeholder="选择商品"
                    suffix-icon="el-icon-search"
                    readonly
                    @focus="handleGoodChoose"></el-input>
        </el-form-item>
        <el-form-item label="产品提供方" prop="provider_type">
          <el-select v-model="dataForm.provider_type" placeholder="请选择产品提供方">
            <el-option label="平台" :value="1"></el-option>
            <el-option label="学长" :value="2"></el-option>
            <el-option label="主理人" :value="3"></el-option>
            <el-option label="合作机构" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isPurchase" label="服务对象" prop="service_user_type">
          <el-select v-model="dataForm.service_user_type" placeholder="请选择">
            <el-option label="学员" :value="1"></el-option>
            <el-option label="加盟商" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isPurchase" label="采购折扣" prop="sale_percent">
          <el-input v-model="dataForm.sale_percent" placeholder="请输入采购折扣">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="isShare" label="分佣比例" prop="recommend_fee_percent">
          <el-input v-model="dataForm.recommend_fee_percent" placeholder="请输入分佣比例">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="dataForm.foster_type === 4" label="平台分成" prop="platform_fee_percent">
          <el-input v-model="dataForm.platform_fee_percent" placeholder="请输入整数百分比（0-100）">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="isPurchase" label="起订份数" prop="base_order_count">
          <el-input v-model="dataForm.base_order_count" type="number" placeholder="请输入起订份数">
            <template slot="append">份</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-select v-model="dataForm.categories"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     placeholder="输入分类后按回车添加"
                     style="width: 100%">
          </el-select>
        </el-form-item>
        <el-form-item :label="institutionLabel" prop="institutions">
          <div class="tag-wrap">
            <el-tag v-for="item in dataForm.institutions"
                    :key="item.id"
                    class="subject-item"
                    closable
                    @close="handleInstitutionRemove(item)">{{ item.name }}</el-tag>
          <el-button type="text" @click="handleInstitutionChoose">选择机构</el-button>
          <div v-if="institutionLimit" class="field-tip">{{ institutionLimit === 1 ? '请选择1个机构' : '请选择1至10个机构' }}</div>
          </div>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值"></el-input>
        </el-form-item>
        <el-form-item v-if="isShare" label="分享文案" prop="share_text">
          <el-input v-model="dataForm.share_text"
                    type="textarea"
                    :rows="4"
                    maxlength="500"
                    show-word-limit
                    placeholder="请输入分享文案，最多500字"></el-input>
        </el-form-item>
        <el-form-item v-if="isShare" label="分享图片">
          <el-upload :action="imgUploadUrl"
                     :headers="uploadHeaders"
                     :file-list="shareImageList"
                     accept="image/*"
                     list-type="picture-card"
                     :limit="9"
                     :on-success="handleShareImageSuccess"
                     :on-remove="handleShareImageRemove"
                     :on-preview="handleShareImagePreview"
                     :before-upload="handleBeforeShareImageUpload"
                     :on-exceed="handleShareImageExceed">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多上传 9 张图片</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose :visible="goodChooseDialog"
                   :ref_type="productType"
                   @close="goodChooseDialog = false"
                   @submit="saveGood"></ContentChoose>
    <InstitutionChoose :visible="institutionChooseDialog"
                       :colleges="dataForm.institutions"
                       :max-selection="institutionLimit"
                       @close="institutionChooseDialog = false"
                       @submit="saveInstitution"></InstitutionChoose>
    <el-dialog :visible.sync="shareImagePreviewVisible" append-to-body>
      <img width="100%" :src="shareImagePreviewUrl" alt="分享图片预览">
    </el-dialog>
  </div>
</template>

<script>
import ContentChoose from '@/components/dialog/ContentChoose'
import InstitutionChoose from '@/components/dialog/warrant/InstitutionChoose'
import { updateWarrantProduct } from '@/api/warrant'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

const percentageRule = (rule, value, callback) => {
  const number = Number(value)
  if (value === '' || value === null || value === undefined || Number.isNaN(number) || number < 0 || number > 100) {
    callback(new Error('比例范围为0-100'))
    return
  }
  callback()
}

const platformPercentageRule = (rule, value, callback) => {
  const number = Number(value)
  if (value === null || value === undefined || String(value).trim() === '' || !Number.isInteger(number) || number < 0 || number > 100) {
    callback(new Error('平台分成请输入0-100的整数百分比'))
    return
  }
  callback()
}

export default {
  components: { ContentChoose, InstitutionChoose },
  props: {
    visible: { type: Boolean, default: false },
    content: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialogVisible: this.visible,
      productType: 1,
      goodChooseDialog: false,
      institutionChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      shareImageList: [],
      shareImagePreviewUrl: '',
      shareImagePreviewVisible: false,
      dataForm: this.getInitialForm(),
      rules: {
        product_name: [{ required: true, message: '请选择商品', trigger: 'change' }],
        service_user_type: [{ required: true, message: '请选择服务对象', trigger: 'change' }],
        sale_percent: [{ required: true, validator: percentageRule, trigger: 'blur' }],
        recommend_fee_percent: [{ required: true, validator: percentageRule, trigger: 'blur' }],
        platform_fee_percent: [{ required: true, validator: platformPercentageRule, trigger: 'blur' }],
        institutions: [{ validator: this.validateInstitutions, trigger: 'change' }],
        base_order_count: [{ required: true, message: '请输入起订份数', trigger: 'blur' }],
        share_text: [{ max: 500, message: '分享文案最多500字', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isPurchase() {
      return this.dataForm.foster_type === 1
    },
    isShare() {
      return this.dataForm.foster_type === 2
    },
    institutionLimit() {
      return this.dataForm.foster_type === 3 ? 10 : this.dataForm.foster_type === 4 ? 1 : 0
    },
    institutionLabel() {
      return this.dataForm.foster_type === 3 ? '主理机构' : this.dataForm.foster_type === 4 ? '合作机构' : '专属机构'
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
      if (value && this.content && Object.keys(this.content).length) this.initFormData()
    },
  },
  methods: {
    getInitialForm() {
      return {
        id: '',
        foster_type: 1,
        product_id: '',
        product_name: '',
        service_user_type: '',
        sale_percent: '',
        recommend_fee_percent: '',
        platform_fee_percent: '',
        provider_type: '',
        base_order_count: 1,
        share_text: '',
        categories: [],
        institutions: [],
        sort: '',
        status: 1,
      }
    },
    initFormData() {
      const fosterType = Number(this.content.foster_type || 1)
      this.productType = Number(this.content.product_type || 1)
      this.shareImageList = this.getShareImageList(this.content.share_img_urls)
      this.dataForm = {
        id: this.content.id,
        foster_type: fosterType,
        product_id: this.content.product_id || '',
        product_name: this.content.product_name || '',
        service_user_type: this.content.service_user_type || '',
        sale_percent: this.content.sale_percent === null || this.content.sale_percent === undefined ? '' : this.content.sale_percent,
        recommend_fee_percent: this.content.recommend_fee_percent === null || this.content.recommend_fee_percent === undefined ? '' : Number(this.content.recommend_fee_percent) * 100,
        platform_fee_percent: this.content.platform_fee_percent === null || this.content.platform_fee_percent === undefined ? '' : Number((Number(this.content.platform_fee_percent) * 100).toFixed(2)),
        provider_type: this.content.provider_type === null || this.content.provider_type === undefined ? '' : Number(this.content.provider_type),
        base_order_count: this.content.base_order_count === null || this.content.base_order_count === undefined ? 1 : this.content.base_order_count,
        share_text: this.content.share_text || '',
        categories: this.getCategories(this.content),
        institutions: this.getInstitutions(this.content),
        sort: this.content.sort === null || this.content.sort === undefined ? '' : this.content.sort,
        status: this.content.status,
      }
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    getCategories(content) {
      if (Array.isArray(content.arr_ref_category)) {
        return content.arr_ref_category.map((item) => item.category_name).filter(Boolean)
      }
      return content.category_name ? content.category_name.split(',').map((item) => item.trim()).filter(Boolean) : []
    },
    getInstitutions(content) {
      if (Array.isArray(content.arr_ref_company)) {
        return content.arr_ref_company.map((item) => ({ id: item.cid, name: item.company_name }))
      }
      const ids = content.ref_cids ? content.ref_cids.split(',') : []
      const names = content.ref_company_names ? content.ref_company_names.split(',') : []
      return ids.map((id, index) => ({ id: Number(id), name: names[index] || id }))
    },
    formatFosterType(value) {
      return ({ 1: '渠道分销', 2: '分享推广', 3: '主理人合作', 4: '机构合作' })[Number(value)] || '--'
    },
    validateInstitutions(rule, value, callback) {
      const count = Array.isArray(value) ? value.length : 0
      if ((this.dataForm.foster_type === 3 || this.dataForm.foster_type === 4) && count === 0) {
        callback(new Error('请选择关联机构'))
      } else if (this.institutionLimit && count > this.institutionLimit) {
        callback(new Error(`最多选择${this.institutionLimit}个机构`))
      } else {
        callback()
      }
    },
    handleProductTypeChange() {
      this.dataForm.product_id = ''
      this.dataForm.product_name = ''
    },
    handleGoodChoose() {
      this.goodChooseDialog = true
    },
    saveGood(product) {
      this.dataForm.product_id = product.id
      this.dataForm.product_name = product.name
      this.goodChooseDialog = false
    },
    handleInstitutionChoose() {
      this.institutionChooseDialog = true
    },
    saveInstitution({ colleges }) {
      this.dataForm.institutions = [...colleges]
      this.institutionChooseDialog = false
      this.$refs.dataForm.validateField('institutions')
    },
    handleInstitutionRemove(item) {
      this.dataForm.institutions = this.dataForm.institutions.filter((value) => value.id !== item.id)
      this.$refs.dataForm.validateField('institutions')
    },
    normalizedCategories() {
      return [...new Set(this.dataForm.categories.map((value) => String(value).trim()).filter(Boolean))]
    },
    normalizedShareImageUrls() {
      return this.shareImageList.map((item) => item.url).filter(Boolean).join(',')
    },
    getShareImageList(urls) {
      return String(urls || '')
        .split(',')
        .map((url, index) => url.trim() ? { name: `分享图片${index + 1}`, url: url.trim() } : null)
        .filter(Boolean)
    },
    handleShareImageSuccess(response, file, fileList) {
      if (response.code !== 0 || !response.data || !response.data.url) {
        this.$message.error(response.msg || '图片上传失败')
        return
      }
      this.shareImageList = fileList.map((item) => ({
        name: item.name,
        url: item.response && item.response.data ? item.response.data.url : item.url,
      })).filter((item) => item.url)
    },
    handleShareImageRemove(file, fileList) {
      this.shareImageList = fileList.map((item) => ({ name: item.name, url: item.url })).filter((item) => item.url)
    },
    handleShareImagePreview(file) {
      this.shareImagePreviewUrl = file.url
      this.shareImagePreviewVisible = true
    },
    handleBeforeShareImageUpload(file) {
      if (file.type && file.type.indexOf('image/') === 0) return true
      this.$message.error('只能上传图片文件')
      return false
    },
    handleShareImageExceed() {
      this.$message.error('分享图片最多上传9张')
    },
    buildParams() {
      const params = {
        id: this.dataForm.id,
        foster_type: this.dataForm.foster_type,
        product_id: this.dataForm.product_id,
        product_type: this.productType,
        arr_category_name: this.normalizedCategories(),
        arr_ref_cid: this.dataForm.institutions.map((item) => item.cid || item.id),
        sort: this.dataForm.sort,
        status: this.dataForm.status,
      }
      if (this.dataForm.provider_type !== '') params.provider_type = this.dataForm.provider_type
      if (this.isPurchase) {
        params.service_user_type = this.dataForm.service_user_type
        params.sale_percent = Number(this.dataForm.sale_percent)
        params.base_order_count = Number(this.dataForm.base_order_count)
      } else if (this.isShare) {
        params.service_user_type = 1
        params.recommend_fee_percent = Number(this.dataForm.recommend_fee_percent) / 100
        params.share_text = this.dataForm.share_text.trim()
        params.share_img_urls = this.normalizedShareImageUrls()
      } else if (this.dataForm.foster_type === 4) {
        params.platform_fee_percent = Number(this.dataForm.platform_fee_percent) / 100
      }
      return params
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid || !this.dataForm.product_id) {
          if (!this.dataForm.product_id) this.$message.error('请选择商品')
          return
        }
        updateWarrantProduct(this.buildParams()).then(() => {
          this.$message.success('修改成功')
          this.$emit('submit')
          this.handleClose()
        })
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.tag-wrap { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.subject-item { margin: 0; }
.field-tip { color: #909399; font-size: 12px; line-height: 20px; }
.upload-tip { color: #909399; font-size: 12px; line-height: 20px; }
/deep/ .el-upload--picture-card,
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 96px;
  height: 96px;
  line-height: 96px;
  margin: 0 8px 8px 0;
}
</style>
